.logoutButton {
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 4px;
  // 40px keeps a usable touch target; the design box is the 20px content row.
  height: 40px;
  padding: 0 4px;

  &:hover {
    background-color: #f2f2f2;
  }

  img {
    height: 20px;
    width: 20px;
  }
}

.label {
  color: #1a1a23;
  font-family: "Montserrat Medium", sans-serif;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
}
